<template>
<div class="chapter">
<div class="inner_page">
<div class="epigraphPage">
<a id="title15"></a>
<div class="verse"><span><em class="i">Man has not one and the same life. He has many lives,<br/> placed end to end, and that is the cause of his misery.</em></span></div>
<div class="source"><span>—Chateaubriand</span></div></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9781466817654_epi01.vue?008d8ee3